/* Receptenoverzicht: filter zonder JavaScript-fallback te verbergen. */
(() => {
  const overview = document.querySelector('[data-aza-recipes]');
  if (!overview) return;
  const filters = overview.querySelector('[data-recipe-filters]');
  const buttons = [...filters.querySelectorAll('[data-recipe-filter]')];
  const cards = [...overview.querySelectorAll('[data-recipe-group]')];
  const count = overview.querySelector('[data-recipe-count]');
  filters.hidden = false;
  filters.addEventListener('click', (event) => {
    const button = event.target.closest('[data-recipe-filter]');
    if (!button || !filters.contains(button)) return;
    const group = button.dataset.recipeFilter;
    buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
    let visible = 0;
    cards.forEach((card) => {
      card.hidden = group !== 'all' && card.dataset.recipeGroup !== group;
      if (!card.hidden) visible += 1;
    });
    count.textContent = `${visible} ${count.dataset.countLabel}`;
  });
})();

/* Aza DIY-recept (upgrade oktober 2026): rekent de grammen mee met de gekozen
   hoeveelheid, kiest per ingrediënt een verpakking die groot genoeg is, laat
   uitvinken wat al in huis is, en houdt totaal, 'genoeg voor' en 'per batch'
   bij. Een uitverkocht ingrediënt blokkeert de rest niet meer. */
(() => {
  const recipe = document.querySelector('[data-aza-recipe]');
  if (!recipe) return;

  const language = recipe.dataset.locale || 'nl';
  const translations = {
    nl: { soldOut: 'Uitverkocht', restOk: (n) => `${n} is uitverkocht. De rest kun je wel bestellen.`, small: 'Kies een grotere verpakking voor deze hoeveelheid.', adding: 'Ingrediënten worden toegevoegd…', added: 'Ingrediënten toegevoegd aan de winkelmand.', failed: 'Toevoegen is niet gelukt. Probeer het opnieuw.', copied: 'Link gekopieerd.', saved: 'Bewaard', save: 'Bewaar recept', none: 'Niets aangevinkt', times: (n) => `${n}× dit recept`, approx: (v) => `± ${v}` },
    de: { soldOut: 'Ausverkauft', restOk: (n) => `${n} ist ausverkauft. Den Rest kannst du trotzdem bestellen.`, small: 'Wähle für diese Menge eine größere Packung.', adding: 'Zutaten werden hinzugefügt…', added: 'Zutaten im Warenkorb.', failed: 'Das Hinzufügen hat nicht funktioniert. Bitte erneut versuchen.', copied: 'Link kopiert.', saved: 'Gespeichert', save: 'Rezept speichern', none: 'Nichts ausgewählt', times: (n) => `${n}× dieses Rezept`, approx: (v) => `± ${v}` },
    fr: { soldOut: 'Épuisé', restOk: (n) => `${n} est épuisé. Vous pouvez commander le reste.`, small: 'Choisissez un emballage plus grand pour cette quantité.', adding: 'Ajout des ingrédients…', added: 'Ingrédients ajoutés au panier.', failed: 'Impossible d’ajouter les ingrédients. Réessayez.', copied: 'Lien copié.', saved: 'Enregistrée', save: 'Enregistrer', none: 'Rien de sélectionné', times: (n) => `${n}× cette recette`, approx: (v) => `± ${v}` },
    en: { soldOut: 'Sold out', restOk: (n) => `${n} is sold out. You can still order the rest.`, small: 'Choose a larger package for this batch size.', adding: 'Adding ingredients…', added: 'Ingredients added to cart.', failed: 'Could not add the ingredients. Please try again.', copied: 'Link copied.', saved: 'Saved', save: 'Save recipe', none: 'Nothing selected', times: (n) => `${n}× this recipe`, approx: (v) => `± ${v}` }
  };
  const copy = translations[language] || translations.en;
  const batches = [...recipe.querySelectorAll('[data-recipe-batch]')];
  const rows = [...recipe.querySelectorAll('[data-recipe-ingredient]')];
  const total = recipe.querySelector('[data-recipe-total]');
  const cart = recipe.querySelector('[data-recipe-cart]');
  const status = recipe.querySelector('[data-recipe-status]');
  const timesEl = recipe.querySelector('[data-recipe-times]');
  const perBatchEl = recipe.querySelector('[data-recipe-per-batch]');
  const cartLabel = recipe.dataset.cartLabel || cart.textContent.trim();
  const currency = window.Shopify?.currency?.active || 'EUR';
  const tag = { nl: 'nl-NL', de: 'de-DE', fr: 'fr-FR', en: 'en-GB' }[language] || 'nl-NL';
  // Het thema schrijft '€8,95' zonder spatie na het teken.
  const money = (cents) => new Intl.NumberFormat(tag, { style: 'currency', currency }).format(cents / 100).replace(/^(\D+)\s/, '$1');
  const setStatus = (message) => { status.textContent = message; status.dataset.own = ''; };
  const grams = () => Number((batches.find((b) => b.checked) || batches[0])?.value || 0);

  const capacityInGrams = (option) => {
    const label = option.textContent.replace(/\s+/g, ' ');
    const match = label.match(/(?:(\d+)\s*[x×]\s*)?(\d+(?:[.,]\d+)?)\s*(kg|gr|g|ml|l)\b/i);
    if (!match) return null;
    const multiplier = Number(match[1] || 1);
    const size = Number(match[2].replace(',', '.')) * multiplier;
    const unit = match[3].toLowerCase();
    if (unit === 'kg') return size * 1000;
    if (unit === 'l') return size * 800;
    if (unit === 'ml') return size * 0.8;
    return size;
  };

  // Uitverkochte ingrediënten: vinkje uit en vast, zodat de rest wel kan.
  rows.forEach((row) => {
    const select = row.querySelector('[data-recipe-variant]');
    const pick = row.querySelector('[data-recipe-pick]');
    const available = select ? [...select.options].filter((option) => !option.disabled) : [];
    if (!available.length) {
      row.classList.add('is-unavailable');
      pick.checked = false;
      pick.disabled = true;
      if (select) select.disabled = true;
      row.querySelector('[data-recipe-note]').textContent = copy.soldOut;
      return;
    }
    const smallest = available.filter((option) => capacityInGrams(option) !== null).sort((a, b) => capacityInGrams(a) - capacityInGrams(b))[0] || available[0];
    select.value = smallest.value;
    select.addEventListener('change', () => update());
    pick.addEventListener('change', () => update());
  });

  const update = (autoSelect = false) => {
    const batch = grams();
    let price = 0;
    let picked = 0;
    let perBatch = 0;
    let capacityKnown = true;
    let times = Infinity;
    let tooSmall = false;
    const soldOut = [];

    recipe.querySelectorAll('[data-recipe-yield]').forEach((el) => { el.textContent = `${batch.toLocaleString(language)} g`; });

    rows.forEach((row) => {
      const weight = batch * Number(row.dataset.percent) / 100;
      row.querySelector('[data-recipe-amount]').textContent = Number(weight.toFixed(2)).toLocaleString(language);
      const select = row.querySelector('[data-recipe-variant]');
      const pick = row.querySelector('[data-recipe-pick]');
      const priceEl = row.querySelector('[data-recipe-price]');
      if (row.classList.contains('is-unavailable') || !select) {
        soldOut.push(row.dataset.name);
        priceEl.textContent = '';
        return;
      }
      let selected = select.selectedOptions[0];
      // Bij een andere hoeveelheid opnieuw kiezen: de goedkoopste verpakking
      // met genoeg inhoud (dus 1x 100 ml in plaats van 3x 30 ml), bij gelijke
      // prijs de kleinste; is er geen die genoeg heeft, dan de grootste.
      if (autoSelect) {
        const known = [...select.options].filter((option) => !option.disabled && capacityInGrams(option) !== null);
        const enough = known.filter((option) => capacityInGrams(option) >= weight)
          .sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price) || capacityInGrams(a) - capacityInGrams(b))[0];
        const best = enough || known.sort((a, b) => capacityInGrams(b) - capacityInGrams(a))[0];
        if (best) { select.value = best.value; selected = best; }
      }
      const cents = Number(selected?.dataset.price || 0);
      priceEl.textContent = money(cents);
      const capacity = selected ? capacityInGrams(selected) : null;
      const note = row.querySelector('[data-recipe-note]');
      const small = capacity !== null && capacity < weight;
      note.textContent = small ? copy.small : '';
      row.classList.toggle('is-skipped', !pick.checked);
      if (!pick.checked) return;
      picked += 1;
      price += cents;
      if (small) tooSmall = true;
      if (capacity) {
        times = Math.min(times, Math.floor(capacity / weight));
        perBatch += cents * weight / capacity;
      } else {
        capacityKnown = false;
      }
    });

    total.textContent = picked ? money(price) : copy.none;
    cart.disabled = picked === 0;
    cart.textContent = picked ? `${cartLabel} · ${money(price)}` : cartLabel;
    // Zonder bekende inhoud van elke gekozen verpakking (bijv. 'Default Title')
    // is 'genoeg voor' en 'per batch' niet te onderbouwen; dan geen getal.
    const showTimes = picked > 0 && capacityKnown && Number.isFinite(times) && times > 0;
    const showPerBatch = picked > 0 && capacityKnown && perBatch > 0;
    timesEl.textContent = showTimes ? copy.times(times) : '';
    perBatchEl.textContent = showPerBatch ? copy.approx(money(Math.round(perBatch))) : '';
    timesEl.parentElement.hidden = !showTimes;
    perBatchEl.parentElement.hidden = !showPerBatch;
    // Alleen eigen meldingen overschrijven, niet 'toegevoegd' of 'link gekopieerd'.
    const own = status.dataset.own === '1';
    if (soldOut.length) { setStatus(copy.restOk(soldOut.join(', '))); status.dataset.own = '1'; }
    else if (tooSmall) { setStatus(copy.small); status.dataset.own = '1'; }
    else if (own) { setStatus(''); status.dataset.own = ''; }
  };

  batches.forEach((input) => input.addEventListener('change', () => update(true)));
  update(true);

  cart.addEventListener('click', async () => {
    const items = rows
      .filter((row) => !row.classList.contains('is-unavailable') && row.querySelector('[data-recipe-pick]')?.checked)
      .map((row) => ({ id: Number(row.querySelector('[data-recipe-variant]')?.value), quantity: 1 }))
      .filter((item) => item.id);
    if (!items.length || cart.disabled) return;
    cart.disabled = true;
    setStatus(copy.adding);
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error(`Cart returned ${response.status}`);
      setStatus(copy.added);
      try { window.Shopify?.analytics?.publish?.('aza_recipe_add_all', { recipe: window.location.pathname, items: items.length }); } catch (trackError) {}
      if (typeof window.refreshCart === 'function') window.refreshCart();
      else window.location.href = recipe.dataset.cartUrl;
    } catch (error) {
      setStatus(copy.failed);
    } finally {
      cart.disabled = false;
    }
  });

  const save = recipe.querySelector('[data-recipe-save]');
  const storageKey = `aza-recipe:${window.location.pathname}`;
  const updateSaved = (saved) => {
    save.setAttribute('aria-pressed', String(saved));
    save.querySelector('.visually-hidden').textContent = saved ? copy.saved : copy.save;
  };
  try { updateSaved(localStorage.getItem(storageKey) === '1'); } catch (_) { /* Storage kan uit staan. */ }
  save.addEventListener('click', () => {
    const next = save.getAttribute('aria-pressed') !== 'true';
    try { if (next) localStorage.setItem(storageKey, '1'); else localStorage.removeItem(storageKey); }
    catch (_) { /* Pagina blijft bruikbaar zonder storage. */ }
    updateSaved(next);
  });
  recipe.querySelector('[data-recipe-share]').addEventListener('click', async () => {
    try {
      if (navigator.share) await navigator.share({ title: document.title, url: window.location.href });
      else { await navigator.clipboard.writeText(window.location.href); setStatus(copy.copied); }
    } catch (_) { /* Delen geannuleerd of klembord geweigerd. */ }
  });
  recipe.querySelector('[data-recipe-print]').addEventListener('click', () => window.print());

  // De kop van het thema blijft bij scrollen staan. Koopblok en tabs schuiven
  // er direct onder aan (CSS-variabele --recipe-top).
  // De headergroep bestaat uit meerdere secties (aankondigingsbalk, kop);
  // alleen de sectie die sticky is telt.
  const header = [...document.querySelectorAll('.shopify-section-group-header-group')].find((el) => getComputedStyle(el).position === 'sticky');
  const setTop = () => {
    recipe.style.setProperty('--recipe-top', `${header ? Math.round(header.getBoundingClientRect().height) : 0}px`);
  };
  if (header && window.ResizeObserver) new ResizeObserver(setTop).observe(header);
  setTop();

  // Springlinks: de sectie die in beeld is licht op.
  const tabs = [...recipe.querySelectorAll('[data-recipe-tab]')];
  if (tabs.length && window.IntersectionObserver) {
    const byId = new Map(tabs.map((tab) => [tab.getAttribute('href').slice(1), tab]));
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        tabs.forEach((tab) => tab.removeAttribute('aria-current'));
        byId.get(entry.target.id)?.setAttribute('aria-current', 'true');
      });
    }, { rootMargin: '-35% 0px -60% 0px' });
    byId.forEach((tab, id) => {
      const section = document.getElementById(id);
      if (section) observer.observe(section);
    });
  }

  // Vaste balk op mobiel met het totaal en 'alles in winkelmand', zolang het
  // koopblok zelf niet in beeld is (zo overlappen ze nooit).
  const sticky = document.querySelector('[data-recipe-sticky]');
  if (sticky) {
    const stickyTotal = sticky.querySelector('[data-recipe-sticky-total]');
    const stickyCart = sticky.querySelector('[data-recipe-sticky-cart]');
    const buy = recipe.querySelector('.aza-recipe__buy');
    const sync = () => { stickyTotal.textContent = total.textContent; stickyCart.disabled = cart.disabled; };
    new MutationObserver(sync).observe(total, { childList: true, characterData: true, subtree: true });
    new MutationObserver(sync).observe(cart, { attributes: true, attributeFilter: ['disabled'] });
    stickyCart.addEventListener('click', () => cart.click());
    sync();
    sticky.hidden = false;
    // Ook weg zodra de onderkant van de footer in beeld is, anders ligt de
    // balk over de betaalmethoden en de juridische links (zoals de DIY-balk).
    const footBottom = document.querySelector('.aza-foot__bottom');
    let buyVisible = false;
    let footVisible = false;
    const toggle = () => sticky.classList.toggle('is-verborgen', buyVisible || footVisible);
    if (window.IntersectionObserver) {
      if (buy) new IntersectionObserver((entries) => { buyVisible = entries[entries.length - 1].isIntersecting; toggle(); }).observe(buy);
      if (footBottom) new IntersectionObserver((entries) => { footVisible = entries[entries.length - 1].isIntersecting; toggle(); }).observe(footBottom);
    }
  }
})();
